import styles from './contact-list-item.module.scss';

<template>
  <li
    class="{{styles.component}} contact-list-item {{if @isDisabled 'disabled'}}"
    data-test-contact={{@contact.id}}
    data-test-contact-list-item
  >
    {{yield}}
  </li>
</template>
